/* unplugin-vue-components disabled */import { render } from "./News2.vue?vue&type=template&id=679bce5a&scoped=true"
import script from "./News2.vue?vue&type=script&lang=js"
export * from "./News2.vue?vue&type=script&lang=js"

import "./News2.vue?vue&type=style&index=0&id=679bce5a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679bce5a"]])

export default __exports__